import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS machine

export default function UnderWindDRow() {
   return (
      <InputRangeRow
         titleProp={"Underwind D"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={99999}
         propertyNameProp={"underwindD"}
         errorDialogueProp={"0-99,999.9 only"}
         floatProp={true}
      />
   );
}
